// extracted by mini-css-extract-plugin
module.exports = {"recommendation":"styles_recommendation__2We-L","title":"styles_title__jWUvK","content":"styles_content__7ETsG","slider":"styles_slider__3e1xO","slide":"styles_slide__1m2z5"};